import type { User } from '@/server/models'

import type { UserContextType } from '@/client/context/user'

import hasUserRole from './hasUserRole'
import isUserOnboarding from './isUserOnboarding'

export default function isUserPendingApproval(user: UserContextType | User): boolean {
  return (
    (!isUserOnboarding(user) && user.roles.length === 0) || hasUserRole(user, 'user:unapproved')
  )
}
